document.addEventListener('DOMContentLoaded', function() {
    const notice = document.querySelector('.woocommerce-notices-wrapper');
    if (notice) {

        // Initial styles for hidden notice
        notice.style.opacity = 0;
        notice.style.display = 'block';
        notice.style.transition = 'opacity 0.5s ease-in-out, transform 0.5s ease-in-out';

        notice.style.transform = 'translateX(-100%)';

        // Slide in the notice
        setTimeout(() => {
            notice.style.opacity = 1;
            notice.style.transform = 'translateX(0)'; // Slide in from left on desktop

        }, 100);

        // Slide out the notice after 5 seconds
        setTimeout(() => {
            notice.style.opacity = 0;
            notice.style.transform = 'translateX(-100%)'; // Slide out to left on desktop

            setTimeout(() => {
                notice.style.display = 'none'; // Hide notice after animation completes
            }, 500); // Ensure this matches the duration of the transition
        }, 5000);
    }
});

//# sourceMappingURL=wc-notice-show-animation.js.map
